/* ============================================================
   KAMVYA AUG PDP — Shared behaviour
   Loaded by every kamvya-aug-pdp-* section.
   Self-guarded: safe if the browser executes it more than once.
   ============================================================ */
(function () {
  if (window.KamvyaAug) return;
  window.KamvyaAug = { version: '1.0.0' };

  var D = document;
  var qs = function (s, r) { return (r || D).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };

  /* ==========================================================
     CART CONFIG (written by the header section)
     ========================================================== */
  function cartConfig() {
    var el = D.getElementById('KamvyaCartConfig');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  /* ==========================================================
     CART DRAWER HELPERS  (Dawn's native <cart-drawer>)
     ========================================================== */
  function getDrawer() { return qs('cart-drawer'); }

  function openDrawer(drawer) {
    drawer = drawer || getDrawer();
    if (!drawer) return false;
    var inner = qs('.drawer__inner', drawer);
    if (inner) inner.classList.remove('is-empty');
    if (typeof drawer.open === 'function') {
      try { drawer.open(); return true; } catch (e) { /* fall through */ }
    }
    drawer.classList.add('animate', 'active');
    D.body.classList.add('overflow-hidden');
    return true;
  }

  function replaceDrawerHTML(html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('#CartDrawer');
    var current = qs('#CartDrawer');
    if (fresh && current) current.innerHTML = fresh.innerHTML;

    var drawer = getDrawer();
    if (drawer) {
      var ov = qs('#CartDrawer-Overlay', drawer);
      if (ov && typeof drawer.close === 'function') {
        ov.addEventListener('click', function () { drawer.close(); });
      }
      drawer.classList.remove('is-empty');
    }
    decorateDrawer();
  }

  function refreshDrawer(thenOpen) {
    return fetch(window.Shopify && window.Shopify.routes ? '/?sections=cart-drawer' : '/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        replaceDrawerHTML(data['cart-drawer']);
        if (thenOpen) openDrawer();
      })
      .catch(function () { if (thenOpen) openDrawer(); });
  }

  function updateCartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        qsa('[data-kv-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
        decorateDrawer(cart);
        return cart;
      })
      .catch(function () { });
  }

  /* ----- free-delivery bar + trust row inside the native drawer ----- */
  function decorateDrawer(cart) {
    var drawer = getDrawer();
    if (!drawer) return;
    var cfg = cartConfig();

    /* progress bar under the drawer header */
    if (cfg.bar_enabled !== false) {
      var header = qs('.drawer__header', drawer);
      if (header) {
        var bar = qs('.kv-cartbar', drawer);
        if (!bar) {
          bar = D.createElement('div');
          bar.className = 'kv-cartbar';
          bar.innerHTML = '<div class="kv-cartbar__txt"></div><div class="kv-cartbar__track"><div class="kv-cartbar__fill"></div></div>';
          header.insertAdjacentElement('afterend', bar);
        }
        var threshold = parseInt(cfg.free_threshold || 0, 10);
        var total = cart ? cart.total_price : parseInt(drawer.getAttribute('data-kv-total') || '0', 10);
        var pct = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 100;
        var done = threshold <= 0 || total >= threshold;
        bar.classList.toggle('kv-cartbar--done', done);
        qs('.kv-cartbar__fill', bar).style.width = pct + '%';
        var txt = done
          ? (cfg.bar_text_unlocked || 'You have unlocked free delivery.')
          : (cfg.bar_text_locked || 'You are close to free delivery.');
        qs('.kv-cartbar__txt', bar).textContent = txt;
      }
    }

    /* "View full cart" link + trust ticks under the native checkout button */
    var footer = qs('.drawer__footer', drawer);
    if (footer && !qs('.kv-carttrust', footer)) {
      var extra = D.createElement('div');
      var ticks = (cfg.cart_trust || 'Secure checkout|COD available|Free delivery').split('|');
      var html = '';
      if (cfg.cart_link_text !== '') {
        html += '<a class="kv-cartlink" href="/cart">' + (cfg.cart_link_text || 'View full cart') + '</a>';
      }
      html += '<div class="kv-carttrust">';
      ticks.forEach(function (t) {
        if (t.trim()) html += '<span><i class="kv-tick">&#10003;</i>' + t.trim() + '</span>';
      });
      html += '</div>';
      extra.innerHTML = html;
      footer.appendChild(extra);
    }
  }

  /* ==========================================================
     CART OPEN TRIGGERS  (header cart icon, sticky bar, etc.)
     ========================================================== */
  D.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-kv-cart-open]');
    if (!t) return;
    var drawer = getDrawer();
    if (!drawer) return; /* no drawer on this theme -> let the link go to /cart */
    e.preventDefault();
    openDrawer(drawer);
    refreshDrawer(false);
  });

  /* ==========================================================
     ADD TO CART  (native form -> AJAX -> native drawer)
     ========================================================== */
  D.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-kv-product-form]')) return;

    var drawer = getDrawer();
    /* No drawer available? Let Shopify submit normally to /cart. */
    if (!drawer) return;

    e.preventDefault();

    var btn = form.querySelector('[data-kv-add]');
    var errBox = form.parentElement.querySelector('[data-kv-form-error]');
    if (errBox) { errBox.classList.remove('is-on'); errBox.textContent = ''; }
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }

    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          var msg = data.description || data.message || 'Sorry, this could not be added to your cart.';
          if (errBox) { errBox.textContent = msg; errBox.classList.add('is-on'); }
          return;
        }
        if (data.sections && data.sections['cart-drawer']) {
          replaceDrawerHTML(data.sections['cart-drawer']);
          openDrawer();
          updateCartCount();
        } else {
          updateCartCount().then(function () { refreshDrawer(true); });
        }
      })
      .catch(function () {
        if (errBox) { errBox.textContent = 'Network error. Please try again.'; errBox.classList.add('is-on'); }
      })
      .finally(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); btn.disabled = false; }
      });
  });

  /* ==========================================================
     VARIANT PICKER
     ========================================================== */
  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kv-variant]');
    if (!b) return;
    var root = b.closest('[data-kv-buybox]');
    if (!root) return;

    var data = {};
    try { data = JSON.parse(qs('[data-kv-variant-data]', root).textContent); } catch (err) { return; }

    var id = b.getAttribute('data-kv-variant');
    var v = data.filter(function (x) { return String(x.id) === String(id); })[0];
    if (!v) return;

    qsa('[data-kv-variant]', root).forEach(function (x) { x.classList.remove('is-on'); });
    b.classList.add('is-on');

    var input = qs('[data-kv-variant-input]', root);
    if (input) input.value = v.id;

    var now = qs('[data-kv-price-now]', root); if (now) now.textContent = v.price;
    var was = qs('[data-kv-price-was]', root);
    if (was) { was.textContent = v.compare || ''; was.style.display = v.compare ? '' : 'none'; }
    var off = qs('[data-kv-price-off]', root);
    if (off) { off.textContent = v.off || ''; off.style.display = v.off ? '' : 'none'; }

    qsa('[data-kv-price-mirror]').forEach(function (m) { m.textContent = v.price; });
    qsa('[data-kv-was-mirror]').forEach(function (m) {
      m.textContent = v.compare || ''; m.style.display = v.compare ? '' : 'none';
    });

    var add = qs('[data-kv-add]', root);
    if (add) {
      add.disabled = !v.available;
      var label = qs('.kv-btn__text', add);
      if (label) label.textContent = v.available ? add.getAttribute('data-kv-label') : (add.getAttribute('data-kv-sold') || 'Sold out');
    }
    var ctaMirror = qsa('[data-kv-cta-price]');
    ctaMirror.forEach(function (m) { m.textContent = v.price; });
  });

  /* ==========================================================
     GALLERY
     ========================================================== */
  function initGallery(root) {
    if (root.hasAttribute('data-kv-init')) return;
    root.setAttribute('data-kv-init', '1');

    var track = qs('[data-kv-gal-track]', root);
    if (!track) return;
    var dots = qsa('[data-kv-gal-dot]', root);
    var thumbs = qsa('[data-kv-gal-thumb]', root);
    var counter = qs('[data-kv-gal-num]', root);

    function sync() {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); });
      if (counter) counter.textContent = i + 1;
      qsa('video', track).forEach(function (v, j) { if (j !== i) { try { v.pause(); } catch (e) { } } });
    }
    track.addEventListener('scroll', sync, { passive: true });

    function go(i) { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });

    var speed = parseInt(root.getAttribute('data-kv-autoplay') || '0', 10);
    if (speed > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var timer = setInterval(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        var next = (i + 1) % track.children.length;
        go(next);
      }, speed);
      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      track.addEventListener('touchstart', function () { clearInterval(timer); }, { passive: true });
    }
    sync();
  }

  /* ==========================================================
     ANNOUNCEMENT ROTATOR
     ========================================================== */
  function initAnnounce(root) {
    if (root.hasAttribute('data-kv-init')) return;
    root.setAttribute('data-kv-init', '1');
    var items = qsa('.kv-announce__item', root);
    if (items.length < 2) return;
    var speed = parseInt(root.getAttribute('data-kv-speed') || '3500', 10);
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, speed);
  }

  /* ==========================================================
     ACCORDIONS
     ========================================================== */
  D.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('[data-kv-acc-q]');
    if (!q) return;
    var acc = q.closest('.kv-acc');
    var panel = qs('[data-kv-acc-a]', acc);
    var open = acc.classList.toggle('is-open');
    q.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
  });

  /* ==========================================================
     MOBILE NAV
     ========================================================== */
  D.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-kv-nav-open]');
    var close = e.target.closest && e.target.closest('[data-kv-nav-close]');
    if (open) {
      e.preventDefault();
      var nav = qs('[data-kv-nav]');
      if (nav) { nav.classList.add('is-open'); D.body.classList.add('kv-noscroll'); }
    }
    if (close) {
      var n = qs('[data-kv-nav]');
      if (n) { n.classList.remove('is-open'); D.body.classList.remove('kv-noscroll'); }
    }
  });

  /* ==========================================================
     REVIEWS — filter, load more, modal
     ========================================================== */
  function reviewItems(root) { return qsa('[data-kv-review]', root); }

  function applyReviewFilter(root) {
    var filter = root.getAttribute('data-kv-filter') || 'all';
    var limit = parseInt(root.getAttribute('data-kv-limit') || '999', 10);
    var shown = 0;
    var hiddenLeft = 0;
    reviewItems(root).forEach(function (card) {
      var type = card.getAttribute('data-kv-type');
      var match = (filter === 'all') || (type === filter);
      if (match && shown < limit) { card.style.display = ''; shown++; }
      else { card.style.display = 'none'; if (match) hiddenLeft++; }
    });
    var empty = qs('[data-kv-review-empty]', root);
    if (empty) empty.style.display = shown === 0 ? '' : 'none';
    var more = qs('[data-kv-review-more]', root);
    if (more) more.style.display = hiddenLeft > 0 ? '' : 'none';
  }

  D.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-kv-review-tab]');
    if (tab) {
      var root = tab.closest('[data-kv-reviews]');
      qsa('[data-kv-review-tab]', root).forEach(function (t) { t.classList.remove('is-on'); });
      tab.classList.add('is-on');
      root.setAttribute('data-kv-filter', tab.getAttribute('data-kv-review-tab'));
      root.setAttribute('data-kv-limit', root.getAttribute('data-kv-initial') || '4');
      applyReviewFilter(root);
      return;
    }
    var more = e.target.closest && e.target.closest('[data-kv-review-more]');
    if (more) {
      var r2 = more.closest('[data-kv-reviews]');
      r2.setAttribute('data-kv-limit', '999');
      applyReviewFilter(r2);
    }
  });

  /* ---------- modal ---------- */
  var modal, modalGroup = [], modalIndex = 0;

  function buildModal() {
    if (modal) return modal;
    modal = D.createElement('div');
    modal.className = 'kv-modal kv';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="kv-modal__overlay" data-kv-modal-close></div>' +
      '<div class="kv-modal__box">' +
      '<button class="kv-modal__close" data-kv-modal-close aria-label="Close">&times;</button>' +
      '<div class="kv-modal__media" data-kv-modal-media></div>' +
      '<div class="kv-modal__body">' +
      '<div class="kv-modal__stars" data-kv-modal-stars></div>' +
      '<div class="kv-modal__text" data-kv-modal-text></div>' +
      '<div class="kv-modal__meta">' +
      '<div class="kv-modal__av" data-kv-modal-av></div>' +
      '<div><div class="kv-modal__name" data-kv-modal-name></div><div class="kv-modal__loc" data-kv-modal-loc></div></div>' +
      '<div class="kv-modal__ver" data-kv-modal-ver>&#10003; Verified</div>' +
      '</div></div>' +
      '<div class="kv-modal__nav"><button data-kv-modal-prev>&larr; Previous</button><button data-kv-modal-next>Next &rarr;</button></div>' +
      '</div>';
    D.body.appendChild(modal);
    return modal;
  }

  function stars(n) {
    n = parseInt(n || 5, 10);
    var s = '';
    for (var i = 0; i < 5; i++) s += (i < n) ? '\u2605' : '\u2606';
    return s;
  }

  function fillModal(card) {
    buildModal();
    var type = card.getAttribute('data-kv-type');
    var img = card.getAttribute('data-kv-img');
    var video = card.getAttribute('data-kv-video');
    var embed = card.getAttribute('data-kv-embed');
    var poster = card.getAttribute('data-kv-poster');

    var media = qs('[data-kv-modal-media]', modal);
    media.innerHTML = '';
    if (type === 'video' && video) {
      media.innerHTML = '<video controls autoplay playsinline preload="metadata"' +
        (poster ? ' poster="' + poster + '"' : '') + ' src="' + video + '"></video>';
    } else if (type === 'video' && embed) {
      media.innerHTML = '<iframe src="' + embed + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
    } else if (img) {
      media.innerHTML = '<img src="' + img + '" alt="">';
    } else {
      media.style.display = 'none';
    }
    if (media.innerHTML) media.style.display = '';

    qs('[data-kv-modal-stars]', modal).textContent = stars(card.getAttribute('data-kv-rating'));
    qs('[data-kv-modal-text]', modal).innerHTML = card.getAttribute('data-kv-text') || '';
    qs('[data-kv-modal-name]', modal).textContent = card.getAttribute('data-kv-name') || '';
    qs('[data-kv-modal-loc]', modal).textContent = card.getAttribute('data-kv-loc') || '';
    qs('[data-kv-modal-ver]', modal).style.display =
      card.getAttribute('data-kv-verified') === 'true' ? '' : 'none';

    var av = qs('[data-kv-modal-av]', modal);
    var avImg = card.getAttribute('data-kv-avatar');
    var nm = (card.getAttribute('data-kv-name') || '?').trim();
    av.innerHTML = avImg ? '<img src="' + avImg + '" alt="">' : nm.charAt(0).toUpperCase();

    qs('[data-kv-modal-prev]', modal).disabled = modalIndex <= 0;
    qs('[data-kv-modal-next]', modal).disabled = modalIndex >= modalGroup.length - 1;
    qs('.kv-modal__nav', modal).style.display = modalGroup.length > 1 ? '' : 'none';
  }

  function openModal(card) {
    var root = card.closest('[data-kv-reviews]');
    modalGroup = root
      ? reviewItems(root).filter(function (c) { return c.style.display !== 'none'; })
      : [card];
    modalIndex = modalGroup.indexOf(card);
    if (modalIndex < 0) { modalGroup = [card]; modalIndex = 0; }
    fillModal(card);
    modal.classList.add('is-open');
    D.body.classList.add('kv-noscroll');
  }

  function closeModal() {
    if (!modal) return;
    var v = qs('video', modal); if (v) { try { v.pause(); } catch (e) { } }
    qs('[data-kv-modal-media]', modal).innerHTML = '';
    modal.classList.remove('is-open');
    D.body.classList.remove('kv-noscroll');
  }

  D.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-kv-review]');
    if (card) { e.preventDefault(); openModal(card); return; }
    if (e.target.closest && e.target.closest('[data-kv-modal-close]')) { closeModal(); return; }
    if (e.target.closest && e.target.closest('[data-kv-modal-prev]')) {
      if (modalIndex > 0) { modalIndex--; fillModal(modalGroup[modalIndex]); } return;
    }
    if (e.target.closest && e.target.closest('[data-kv-modal-next]')) {
      if (modalIndex < modalGroup.length - 1) { modalIndex++; fillModal(modalGroup[modalIndex]); } return;
    }
  });
  D.addEventListener('keydown', function (e) {
    if (!modal || !modal.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowLeft' && modalIndex > 0) { modalIndex--; fillModal(modalGroup[modalIndex]); }
    if (e.key === 'ArrowRight' && modalIndex < modalGroup.length - 1) { modalIndex++; fillModal(modalGroup[modalIndex]); }
  });

  /* ==========================================================
     STICKY BAR
     ========================================================== */
  function initSticky(bar) {
    if (bar.hasAttribute('data-kv-init')) return;
    bar.setAttribute('data-kv-init', '1');
    var watch = qs('[data-kv-sticky-watch]');
    if (!watch) { bar.classList.add('is-shown'); return; }
    if (!('IntersectionObserver' in window)) { bar.classList.add('is-shown'); return; }
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-shown', !e.isIntersecting && window.scrollY > 250);
    }, { threshold: 0 }).observe(watch);
  }

  /* ==========================================================
     HEADER SHADOW + SCROLL PROGRESS
     ========================================================== */
  function initHeader(hdr) {
    if (hdr.hasAttribute('data-kv-init')) return;
    hdr.setAttribute('data-kv-init', '1');
    var prog = qs('[data-kv-progress]', hdr);
    var onScroll = function () {
      hdr.classList.toggle('is-scrolled', window.scrollY > 8);
      if (prog) {
        var max = D.body.scrollHeight - window.innerHeight;
        prog.style.width = (max > 0 ? (window.scrollY / max * 100) : 0) + '%';
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ==========================================================
     DISPATCH CUTOFF  (a real daily deadline, not a fake timer)
     ========================================================== */
  function initCutoff() {
    var nodes = qsa('[data-kv-cutoff]');
    if (!nodes.length) return;
    function tick() {
      var now = new Date();
      nodes.forEach(function (n) {
        var hour = parseInt(n.getAttribute('data-kv-cutoff') || '18', 10);
        var cut = new Date(now.getTime());
        cut.setHours(hour, 0, 0, 0);
        var slot = n.querySelector('[data-kv-cutoff-value]');
        if (!slot) return;
        if (now >= cut) {
          var after = n.getAttribute('data-kv-cutoff-after');
          slot.textContent = after || 'tomorrow';
          return;
        }
        var ms = cut - now;
        var h = Math.floor(ms / 3600000), m = Math.floor(ms % 3600000 / 60000), s = Math.floor(ms % 60000 / 1000);
        slot.textContent = ('0' + h).slice(-2) + 'h ' + ('0' + m).slice(-2) + 'm ' + ('0' + s).slice(-2) + 's';
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ==========================================================
     41-DOT MANDALA
     ========================================================== */
  function initMandala(el) {
    if (el.hasAttribute('data-kv-init')) return;
    el.setAttribute('data-kv-init', '1');
    var total = parseInt(el.getAttribute('data-kv-days') || '41', 10);
    var marks = (el.getAttribute('data-kv-marks') || '1,7,21,40').split(',').map(function (x) { return parseInt(x.trim(), 10); });
    var html = '';
    for (var i = 1; i <= total; i++) {
      var cls = 'kv-md';
      if (i === total) cls += ' kv-md--final';
      else if (marks.indexOf(i) > -1) cls += ' kv-md--milestone';
      html += '<span class="' + cls + '" title="Day ' + i + '"></span>';
    }
    el.innerHTML = html;
  }

  /* ==========================================================
     INIT / RE-INIT
     ========================================================== */
  function initAll(scope) {
    scope = scope || D;
    qsa('[data-kv-gallery]', scope).forEach(initGallery);
    qsa('[data-kv-announce]', scope).forEach(initAnnounce);
    qsa('[data-kv-sticky]', scope).forEach(initSticky);
    qsa('[data-kv-header]', scope).forEach(initHeader);
    qsa('[data-kv-mandala]', scope).forEach(initMandala);
    qsa('[data-kv-reviews]', scope).forEach(function (r) {
      r.setAttribute('data-kv-limit', r.getAttribute('data-kv-initial') || '999');
      applyReviewFilter(r);
    });
    qsa('.kv-acc.is-open [data-kv-acc-a]').forEach(function (p) { p.style.maxHeight = p.scrollHeight + 'px'; });
    initCutoff();
    decorateDrawer();
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Theme editor support */
  D.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  D.addEventListener('shopify:section:unload', function () { closeModal(); });
  D.addEventListener('shopify:section:select', function (e) { initAll(e.target); });

  /* Keep the drawer decorated after Dawn re-renders it (quantity changes, removals) */
  var drawerObserverTarget = qs('#CartDrawer');
  if (drawerObserverTarget && 'MutationObserver' in window) {
    var mo = new MutationObserver(function () { decorateDrawer(); });
    mo.observe(drawerObserverTarget, { childList: true, subtree: false });
  }

  window.KamvyaAug.openDrawer = openDrawer;
  window.KamvyaAug.refreshDrawer = refreshDrawer;
  window.KamvyaAug.initAll = initAll;
})();